import { defineStore } from 'pinia'
import {setupAxios} from "@/modules/axios.ts";

interface IAppState {
  name?: string
  storage?: string
  session?: any
  csrfToken?: string
  locale: string
  defaultLocale: string
  allowedLanguages: any[]
  public_app_url?: string
  admin_api_url?: string
  media_base_url?: string
  frontend_preview_url?: string
  tinymce_api_key?: string
  environment?: string
  permissions?: any[]

}

export const useAppStore = defineStore({
  id: 'appStore',

  state: (): IAppState => ({
    name: '',
    storage: '',
    session: {
      status: null,
    },
    csrfToken: undefined,
    locale: 'hu',
    defaultLocale: 'hu',
    allowedLanguages: [],
    public_app_url: '',
    admin_api_url: undefined,
    media_base_url: undefined,
    frontend_preview_url: undefined,
    tinymce_api_key: undefined,
    environment: undefined,
    permissions: [],
  }),
  actions: {

    setState (data?: any): void {
      this.name = data?.name
      this.storage = data?.storage
      this.session = data?.session
      this.csrfToken = data?.csrfToken
      this.locale = data?.locale ?? 'hu'
      this.defaultLocale = data?.defaultLocale ?? 'hu'
      this.allowedLanguages = data?.allowedLanguages ?? []
      this.public_app_url = data?.public_app_url ?? ''
      this.admin_api_url = data?.admin_api_url ?? this.admin_api_url ?? undefined
      this.media_base_url = data?.media_base_url ?? this.media_base_url ?? undefined
      this.frontend_preview_url = data?.frontend_preview_url ?? this.frontend_preview_url ?? undefined
      this.tinymce_api_key = data?.tinymce_api_key ?? this.tinymce_api_key ?? undefined
      this.permissions = data?.permissions ?? []
    },



    setAdminApiUrl(url: string): void {
      this.admin_api_url = url
    },

    setMediaBaseUrl(url: string): void {
      this.media_base_url = url
    },

    setFrontendPreviewUrl(url: string): void {
      this.frontend_preview_url = url
    },

    setTinyMceApiKey(key: string): void {
      this.tinymce_api_key = key
    },

    setEnvironment(environment: string): void {
      this.environment = environment
    },

    setCsrfToken (token: string): void {
      this.csrfToken = token
    },

    setValue<K extends keyof IAppState>(key: K, value: IAppState[K]): void {
      this[key] = value
    },
  },
})
